import { TextField, InputAdornment } from "@material-ui/core";
import { PriceFieldProps } from "../../interface/formik/PriceFieldProps";

const PriceField = ({
  label,
  value,
  onChange,
  fullWidth = true,
  disabled = false,
}: PriceFieldProps) => {
  return (
    <TextField
      fullWidth={fullWidth}
      variant="outlined"
      label={label}
      type="number"
      value={value ?? ""}
      onChange={(e) =>
        onChange(e.target.value === "" ? null : parseFloat(e.target.value))
      }
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">$</InputAdornment>
        ),
      }}
      inputProps={{ min: 0, step: "0.01" }}
    />
  );
};

export default PriceField;
